/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SbSharedPriceTile_itemSearch$ref = any;
export type SbRespTradeFreeShippingPromoTile_itemSearch$ref = any;
export type SbRespTradeFreeShippingPromoTile_itemSearch = {
    readonly " $fragmentRefs": SbSharedPriceTile_itemSearch$ref;
    readonly " $refType": SbRespTradeFreeShippingPromoTile_itemSearch$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "SbRespTradeFreeShippingPromoTile_itemSearch",
    "type": "ItemSearchQueryConnection",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "SbSharedPriceTile_itemSearch",
            "args": null
        }
    ]
} as any);
(node as any).hash = 'b18c6827312034d7f6d6894289270497';
export default node;
